import { OptionGroupDef } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f";

export const COGNITIVE_STATUS_GROUPS: OptionGroupDef[] = [
  {
    key: "stage",
    title: "Cognitive staging",
    chooseOne: true,
    options: [
      "Normal cognition",
      "Mild cognitive impairment (MCI)",
      "Mild dementia",
      "Moderate dementia",
      "Severe dementia",
    ],
  },
];
